import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { Grade } from "../models/Grade";
import { MILL_1 } from "@/setup/mill-config/mill-config";

export const getGrades = async (
	params: { includeInactive?: boolean; defaultAreaId?: number } = {},
	signal?: AbortSignal,
): Promise<Grade[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "IncludeInactive", value: params.includeInactive || false },
	];

	const resp = await apiService.callV2(
		params.defaultAreaId == MILL_1.id ? "[M1].[GetGrades]" : "[M2].[GetGrades]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Grade[];
	} else {
		throw new Error(resp.message || "Error fetching grades");
	}
};
